/**
 * Helper: pick a localized string from a CMS field, with fallback.
 * cmsField shape: { sq: "...", en: "..." } OR plain string OR undefined.
 * fallback: translation string to use if cmsField is missing/empty.
 */
export const pickText = (cmsField, lang, fallback = '') => {
  if (cmsField == null) return fallback;
  if (typeof cmsField === 'string') return cmsField || fallback;
  const val = cmsField[lang];
  return (val && String(val).trim()) ? val : fallback;
};

/** Return `cms || fallback` for simple non-translated string fields (email, phone, image url). */
export const pickPlain = (cms, fallback = '') => (cms && String(cms).trim() ? cms : fallback);
